// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-input-form[data-v-51efc6bc]::-webkit-search-cancel-button {\n    -webkit-appearance: none;\n}\n.search-input-form.search-append[data-v-51efc6bc] {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
